<template>
  <div :class="['dropdown', isDarkMode ? 'dark-mode' : '']">
    <button 
      class="dropdown-toggle" 
      :class="{ active: isOpen }" 
      @click="toggleDropdown"
    >
      {{ selectedChatbot?.name || "Select a Bot" }}
      <img :src="isDarkMode ? require('@/assets/icons/arrow_down_dark.svg') : require('@/assets/icons/arrow_down.svg')" alt="Dropdown Arrow" class="arrow" />
    </button>
    <div class="dropdown-menu" v-if= "isOpen">
      <!-- Use v-for to dynamically render chatbot items -->
      <div
        class="dropdown-item"
        v-for="(chatbot, index) in chatbots"
        :key="index"
        @click="selectChatbot(chatbot)">
        {{ chatbot.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    chatbots: {
      type: Array,
      required: true 
    },
    selectedChatbot: {
      type: Object,   // ✅ supports { id, name } and more
      required: true
    },
    isDarkMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isOpen: false,
      // selectedChatbot: null
    };
  },
  // watch: {
  //   // Watch for changes in the chatbots prop and update selectedChatbot
  //   chatbots: {
  //     immediate: true, // This will trigger the watcher when the component is created
  //     handler(newChatbots) {
  //       if (newChatbots && newChatbots.length > 0) {
  //         // this.selectedChatbot = newChatbots[0]; // Set to the name of the first chatbot
  //       }
  //     }
  //   }
  // },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
      console.log('Dropdown is now', this.isOpen);
    },
    selectChatbot(chatbot) {
      // this.selectedChatbot = chatbot;
      this.isOpen = false;
      this.$emit('select-chatbot', chatbot);
    }
  }
};
</script>

<style scoped>
.dropdown {
  display: inline-block;
  position: relative;
}

.dropdown-toggle {
  background-color: transparent; /* Default background color */
  color: black; /* Default text color */
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-family: TT Ramillas Trl, Inter, sans-serif;
  font-size: 1rem;
  margin-top: 0.625rem;
}

.dropdown-toggle.active {
  background-color: #f8f8f8; /* Background color when active */
}

.arrow {
  margin-left: 10px;
  width: 16px; /* Adjust size as needed */
  height: 16px; /* Adjust size as needed */
}

.dropdown-menu {
  /* display: block; */
  position: absolute;
  background-color: white;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
  border-radius: 5px;
  overflow: hidden;
  top: 100%; /* Position below the toggle button */
  left: 0; /* Align to the left edge of the toggle button */
  font-family: TT Ramillias Initials Trl Md Medium, Inter, sans-serif;
}

.dropdown-item {
  padding: 12px 16px;
  cursor: pointer;
}

.dropdown-item:hover {
  background-color: #ddd;
}

/* Dark Mode */
.dark-mode .dropdown-toggle {
  background-color: transparent; /* Keep transparent until active */
  color: #E0E0E0; /* Text color for dark mode */
}

.dark-mode .dropdown-toggle.active {
  background-color: #3A3A3A; /* Background color when active in dark mode */
}

.dark-mode .dropdown-menu {
  background-color: #272727; /* Background color for dark mode */
}

.dark-mode .dropdown-item {
  color: #E0E0E0; /* Text color for dropdown items in dark mode */
}

.dark-mode .dropdown-item:hover {
  background-color: #3A3A3A; /* Hover color for dropdown items in dark mode */
}
</style>
